module.exports = __webpack_public_path__ + "img/complete-vehicle.8e85ed17.png";